import type { PatientBriefResponse } from "@/types/clinician";

export function initialMedicationProduct(
  options: PatientBriefResponse["medication_options"],
) {
  const purchased = options.find((option) => option.purchased);
  if (purchased) return purchased.product_id;
  const defaults = options.filter((option) => option.default_for_program);
  return defaults.length === 1 ? defaults[0].product_id : "";
}
